interface Props {
  isOpen: boolean
  onClose: () => void
  onOpenClientLogin?: () => void
}

const ComingSoonModal = ({ isOpen, onClose, onOpenClientLogin }: Props) => {
  if (!isOpen) return null

  // No external open-login action here; this modal is informational only

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 10000 }}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', maxWidth: '520px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <div className="modal-header" style={{ textAlign: 'center', width: '100%' }}>
          <h2 style={{ margin: 0, width: '100%', textAlign: 'center' }}>Panel Logowania</h2>
        </div>
        <div className="modal-body" style={{ textAlign: 'center', width: '100%' }}>
          <p style={{ margin: '0 auto', maxWidth: 440 }}>Funkcjonalność panelu logowania jest obecnie w fazie przygotowań</p>
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
            <button className="btn-primary" onClick={onClose} style={{ borderRadius: 0 }}>OK</button>
          </div>
        </div>

        {/* Bottom-right icon linking to user login page */}
        <button
          type="button"
          title="Magiczny, tajny, doskonale ukryty przycisk do przyszłości Konfiguratora"
          aria-label="Magiczny, tajny, doskonale ukryty przycisk do przyszłości Konfiguratora"
          onClick={() => {
            try {
              if (onOpenClientLogin) onOpenClientLogin()
            } finally {
              onClose()
            }
          }}
          style={{
            position: 'absolute',
            right: 10,
            bottom: 10,
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textDecoration: 'none',
            color: '#ffffff',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <span style={{ fontSize: 14, lineHeight: 1, color: '#ffffff' }}>×</span>
        </button>
      </div>
    </div>
  )
}

export default ComingSoonModal
